import { Injectable } from '@angular/core';
import { GlobalFilterService } from '@shared-lib/shared-services/global-filter-service';

@Injectable({
  providedIn: 'root',
})
export class CustomGlobalFilterService extends GlobalFilterService {
  /**
   * Always build a flat payload regardless of skipDefaultPayload.
   * The /spriced/platform/ API expects: { key: value, ... }
   */
  override buildPayload(config: any, filters: any[]): any {
    const basePayload =
      config?.customPayload === true ? {}
      : config?.customPayload && typeof config.customPayload === 'object' ? config.customPayload
      : config?.body || config?.requestBody || config?.defaultRequestData || config?.defaultRequesData || {};

    const requestPayload = Array.isArray(filters)
      ? filters.reduce((acc: any, filter: any) => {
          const key = filter?.attributeName;
          const values = filter?.attributeValues ?? filter?.attributeValue;
          if (!key || values === undefined || values === null) return acc;
          if (Array.isArray(values) && values.length === 0) return acc;
          acc[key] = values;
          return acc;
        }, {})
      : {};

    const merged = {
      ...(basePayload && typeof basePayload === 'object' ? basePayload : {}),
      ...requestPayload,
    };

    const preserveNulls = Object.keys(requestPayload).length === 0;
    return Object.entries(merged).reduce((acc: any, [key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0)) return acc;
      if (!preserveNulls && value === null) return acc;
      acc[key] = value;
      return acc;
    }, {});
  }

  /**
   * Overrides updateFilterSelection to handle 'values' being a string instead of an array.
   * All other methods are inherited from GlobalFilterService.
   */
  override updateFilterSelection(
    keyOrKeys: string | string[],
    values: any[] | any, // Allow non-array inputs
    isQueryParam = false,
    widgetId?: string,
    emit: boolean = true,
    filterListener?: string,
    listenerExtraParams?: { [widgetId: string]: { [key: string]: any } },
  ): void {
    const keys = Array.isArray(keyOrKeys)
      ? keyOrKeys
      : (keyOrKeys || '')
          .split(',')
          .map((k) => k.trim())
          .filter((k) => k);

    keys.forEach((key) => {
      // CUSTOM CHANGE: Check if values is array. If not, use it directly.
      const valueToStore = Array.isArray(values) ? values?.[0] || null : values;

      this.selectedFilters[key] = valueToStore;

      if (isQueryParam) {
        this.filters.queryParams[key] = values;
      } else {
        this.filters.requestParams[key] = values;
      }
    });

    this.widgetId = widgetId || null;
    if (emit) {
      const filterData = {
        ...this.filters,
        widgetId: this.widgetId,
        changedFilterKey: keys.length === 1 ? keys[0] : keys,
        filterListener,
        ...(listenerExtraParams ? { listenerExtraParams } : {}),
      };

      this.filterSubject.next(filterData);
      this.currentSelectedFilter.next({ key: keys });
    }
  }
}
